import { useQuery } from "@tanstack/react-query";
import {
  getPartiesPublicIDIdentityDocumentVerifications,
  type IdentityDocumentVerificationDto,
} from "Infrastructure/Api/Api";
import { processResponseWithApiProblemDetails } from "Infrastructure/Api/ApiUtils";

const IDENTITY_DOCUMENT_VERIFICATIONS_QUERY_KEY =
  "IDENTITY_DOCUMENT_VERIFICATIONS";

export const identityDocumentVerificationsKeys = {
  all: [IDENTITY_DOCUMENT_VERIFICATIONS_QUERY_KEY],
  byPublicId: (publicID: string) => [
    ...identityDocumentVerificationsKeys.all,
    publicID,
  ],
};

export const useIdentityDocumentVerificationsQuery = (publicID: string) =>
  useQuery<Array<IdentityDocumentVerificationDto>>({
    queryKey: identityDocumentVerificationsKeys.byPublicId(publicID),
    queryFn: processResponseWithApiProblemDetails(() =>
      getPartiesPublicIDIdentityDocumentVerifications(publicID),
    ),
    refetchOnWindowFocus: false,
  });
